module.exports = __webpack_public_path__ + "assets/jcb.271fd06e6e7a2c52692ffa91a95fb64f.svg";